/**
 * Outlined "galley" wordmark: Fraunces (OFL) at wght 900, SOFT 100, WONK 1, opsz 144,
 * tracking −0.01em, converted to paths with fontTools so the brand never waits for a font
 * (docs/research/06 §6.2). Units are the font's (2000/em); the baseline sits at y=1510.
 */
export const WORDMARK_VIEWBOX = '0 0 5079 2000'
export const WORDMARK_ASPECT = 2.5395

export const WORDMARK_PATH =
  'M652 1371Q551 1359 504 1350Q458 1342 446 1334Q433 1325 433 1316Q433 1308 438 1300' +
  'Q444 1293 456 1286L449 1270Q318 1269 240 1300Q163 1330 130 1378Q97 1427 97 1482' +
  'Q97 1532 126 1574Q156 1616 230 1646Q304 1676 437 1689Q553 1700 610 1713Q667 1726 686 1741' +
  'Q704 1756 704 1774Q704 1788 690 1800Q676 1811 636 1817Q597 1823 519 1823Q384 1823 340 1799' +
  'Q296 1775 296 1735Q296 1715 301 1698Q306 1681 317 1663L275 1637Q130 1644 65 1692' +
  'Q0 1740 0 1814Q0 1876 46 1918Q93 1959 194 1980Q294 2000 456 2000Q755 2000 892 1912' +
  'Q1030 1825 1030 1657Q1030 1571 995 1514Q960 1456 878 1422Q795 1387 652 1371Z' +
  'M610 687 712 699Q734 635 753 614Q772 592 797 592Q821 592 838 605Q855 618 872 634' +
  'Q888 651 910 664Q931 677 964 677Q1018 677 1050 634Q1083 590 1083 515Q1083 435 1043 394' +
  'Q1003 352 930 352Q839 352 764 412Q688 473 640 605ZM957 936Q957 845 907 768Q857 690 758 642' +
  'Q658 595 510 595Q356 595 247 640Q138 686 81 769Q24 852 24 965Q24 1060 78 1134' +
  'Q133 1209 240 1252Q347 1294 504 1294Q641 1294 742 1250Q844 1205 900 1124Q957 1044 957 936Z' +
  'M439 738Q472 730 508 772Q545 815 572 924Q599 1033 587 1088Q575 1143 542 1151' +
  'Q520 1156 496 1140Q472 1123 450 1080Q427 1037 409 965Q391 892 391 844Q391 796 404 770' +
  'Q417 743 439 738ZM1555 1350V1322L1520 1320V806Q1520 772 1506 752Q1491 732 1463 732' +
  'Q1444 732 1429 742Q1414 753 1414 772V819Q1414 900 1365 942Q1316 985 1224 985' +
  'Q1138 985 1098 948Q1058 912 1058 848Q1058 783 1111 725Q1164 667 1270 630Q1376 594 1534 594' +
  'Q1727 594 1813 665Q1899 736 1899 860V1251Q1899 1264 1906 1276Q1912 1287 1930 1287' +
  'Q1939 1287 1946 1284Q1952 1281 1958 1277Q1963 1274 1970 1272Q1976 1269 1984 1269' +
  'Q2004 1269 2015 1288Q2026 1306 2026 1331Q2026 1378 1997 1424Q1968 1470 1914 1500' +
  'Q1861 1530 1787 1530Q1688 1530 1622 1479Q1555 1428 1555 1350ZM1028 1303' +
  'Q1028 1166 1138 1090Q1249 1014 1443 1014Q1485 1014 1521 1019Q1557 1024 1579 1034L1542 1147' +
  'Q1526 1136 1513 1132Q1500 1128 1482 1128Q1448 1128 1428 1154Q1407 1181 1407 1225' +
  'Q1407 1269 1428 1294Q1450 1319 1489 1319Q1512 1319 1530 1310Q1548 1301 1555 1291L1577 1401' +
  'Q1540 1462 1462 1496Q1383 1530 1292 1530Q1168 1530 1098 1466Q1028 1402 1028 1303Z' +
  'M2482 83V1244Q2482 1293 2488 1310Q2493 1328 2504 1337L2514 1346Q2535 1363 2546 1382' +
  'Q2557 1400 2557 1429Q2557 1467 2534 1488Q2512 1510 2474 1510H2111Q2073 1510 2050 1488' +
  'Q2028 1467 2028 1429Q2028 1400 2039 1382Q2050 1363 2071 1346L2081 1337Q2092 1328 2098 1310' +
  'Q2103 1293 2103 1244V359Q2103 320 2096 304Q2088 288 2071 277L2062 271Q2038 255 2028 239' +
  'Q2018 223 2018 198Q2018 169 2035 148Q2052 127 2095 109L2274 36Q2325 15 2354 8' +
  'Q2383 0 2408 0Q2445 0 2464 23Q2482 46 2482 83ZM3037 83V1244Q3037 1293 3042 1310' +
  'Q3048 1328 3059 1337L3069 1346Q3090 1363 3101 1382Q3112 1400 3112 1429Q3112 1467 3090 1488' +
  'Q3067 1510 3029 1510H2666Q2628 1510 2606 1488Q2583 1467 2583 1429Q2583 1400 2594 1382' +
  'Q2605 1363 2626 1346L2636 1337Q2647 1328 2652 1310Q2658 1293 2658 1244V359' +
  'Q2658 320 2650 304Q2643 288 2626 277L2617 271Q2593 255 2583 239Q2573 223 2573 198' +
  'Q2573 169 2590 148Q2607 127 2650 109L2829 36Q2880 15 2909 8Q2938 0 2963 0Q3000 0 3018 23' +
  'Q3037 46 3037 83ZM4033 934Q4033 1017 3990 1062Q3946 1108 3868 1108H3384V976H3592' +
  'Q3650 976 3650 915Q3650 842 3626 811Q3601 780 3569 780Q3543 780 3522 797Q3500 814 3487 852' +
  'Q3474 890 3474 954Q3474 1108 3540 1182Q3607 1257 3719 1257Q3769 1257 3822 1240' +
  'Q3875 1223 3918 1188Q3942 1168 3958 1160Q3974 1153 3987 1153Q4004 1153 4016 1167' +
  'Q4028 1181 4028 1213Q4028 1295 3977 1368Q3926 1440 3832 1485Q3737 1530 3608 1530' +
  'Q3464 1530 3357 1473Q3250 1416 3191 1312Q3132 1209 3132 1071Q3132 935 3188 827' +
  'Q3243 719 3352 656Q3462 594 3622 594Q3751 594 3843 640Q3935 687 3984 764Q4033 842 4033 934' +
  'ZM4729 1315 4495 1678 4132 862Q4117 828 4108 814Q4100 799 4082 783Q4061 763 4053 746' +
  'Q4045 730 4045 705Q4045 663 4068 638Q4090 614 4128 614H4569Q4605 614 4625 636' +
  'Q4645 657 4645 695Q4645 725 4631 741Q4617 757 4593 774L4578 785Q4559 799 4552 828' +
  'Q4545 857 4563 901ZM4453 1729 4524 1559 4612 1375 4786 901Q4801 861 4797 832' +
  'Q4793 803 4765 784L4750 774Q4725 757 4715 741Q4705 725 4705 695Q4705 657 4727 636' +
  'Q4749 614 4787 614H4995Q5033 614 5056 636Q5079 657 5079 695Q5079 720 5070 737' +
  'Q5061 754 5038 775Q5018 794 5005 817Q4992 840 4961 915L4643 1694Q4598 1805 4550 1872' +
  'Q4501 1939 4440 1970Q4379 2000 4295 2000Q4163 2000 4086 1922Q4009 1845 4009 1722' +
  'Q4009 1646 4046 1600Q4083 1555 4153 1555Q4198 1555 4230 1577Q4263 1599 4299 1676L4324 1729' +
  'Q4341 1764 4354 1776Q4367 1788 4387 1788Q4401 1788 4413 1782Q4425 1776 4435 1762' +
  'Q4445 1749 4453 1729Z'
